import { create } from "zustand";

export type MarkerWorld = [number, number, number] | null;

export type MarkerState = {
  markerVisible: boolean;
  markerWorld: MarkerWorld;
};

export type MarkerActions = {
  setMarkerVisible: (visible: boolean) => void;
  setMarkerWorld: (world: MarkerWorld) => void;
  clearMarkerWorld: () => void;
};

export type MarkerStore = MarkerState & { actions: MarkerActions };

export const createMarkerStore = () =>
  create<MarkerStore>((set) => ({
    markerVisible: false,
    markerWorld: null,
    actions: {
      setMarkerVisible: (visible) =>
        set((state) => {
          const nextVisible = visible === true;
          if (state.markerVisible === nextVisible) return state;
          return { markerVisible: nextVisible };
        }),
      setMarkerWorld: (world) => {
        if (!Array.isArray(world) || world.length < 3) {
          set((state) => (state.markerWorld === null ? state : { markerWorld: null }));
          return;
        }
        const x = Number(world[0]) || 0;
        const y = Number(world[1]) || 0;
        const z = Number(world[2]) || 0;
        set((state) => {
          const prev = state.markerWorld;
          if (
            Array.isArray(prev) &&
            prev.length >= 3 &&
            Number(prev[0]) === x &&
            Number(prev[1]) === y &&
            Number(prev[2]) === z
          ) {
            return state;
          }
          return { markerWorld: [x, y, z] };
        });
      },
      clearMarkerWorld: () =>
        set((state) => (state.markerWorld === null ? state : { markerWorld: null })),
    },
  }));
